<template>
  <div class="login__wrap">
    <div class="login__head">
      <el-image class="logoImg" :src="require('@/assets/img/logo.png')"></el-image>
      <span class="logo-title">管理端</span>
    </div>
    <div class="login__bg">
      <div class="login__main">
        <div class="login-title">你有需求 我有空</div>
        <div class="login__box">
          <el-form
            class="sign__main"
            ref="elForm"
            :model="form.data"
            :rules="form.rules"
            @submit.prevent="submit"
          >
            <el-form-item prop="account">
              <el-input v-model.trim="form.data.account" clearable placeholder="请输入账号" prefix-icon="el-icon-user"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model.trim="form.data.password" clearable show-password placeholder="请输入密码" prefix-icon="el-icon-key"></el-input>
            </el-form-item>
            <el-form-item style="margin-top: 50px;">
              <el-button class="theneBtn" style="width: 100%;padding: 15px 40px;" type="primary" :loading="form.loading" :disabled="form.loading" @click.stop="submit">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="foot">-江西村头宝信息科技有限公司技术支持-</div>
    </div>
  </div>
</template>
<script>
import {setStorage} from '@/storage/index.js'
import store from '@/store'
export default {
  name: 'Login',
  data() {
    return {
      form: {
        data: {
          // account: '18679038557',
          // password: '038557',
          account: '',
          password: '',
        },
        rules: {
          account: [{ required: true, message: '请输入用户名', trigger:'blur' }],
          password: [{ required: true, message: '请输入正确密码', trigger:'blur' }],
        }
      },
    }
  },
  methods: {
     submit() {
      this.$refs.elForm.validate((valid) => {
        if (valid) {
          this.$http.post('/admin/flex_login/login', this.form.data).then(res => {
            if(res.code === 1) {
              setStorage('token', res.data.token)
              setStorage('role_type', res.data.role_type)
              setStorage('userName', res.data.name)
              setStorage('router', res.data.permission)
              store.dispatch('setRouter', res.data.permission)
              this.$router.push(res.data.permission[0].children[0].path)
              this.$store.dispatch('setRouter', res.data.permission)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.login__wrap {
  width: 100%;
  height: 100vh;

  .login__head {
    height: 65px;
    background: #fff;
    display: flex;
    align-items: center;
    padding: 0 60px;
    .logo-title {
      margin-left: 12px;
      font-size: 20px;
      font-weight: bold;
      color: #303133;
      line-height: 1;
    }
  }

  .login__bg {
    height: calc(100vh - 65px);
    background-image: url('~@/assets/img/bg.png');
    background-size:cover;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  
  .login__main {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .login-title {
      font-size: 22px;
      font-weight: bold;
      text-align: center;
      color: #303133;
      margin-top: 0;
    }

    .login__box {
      width: 400px;
      padding: 40px;
      border-radius: 10px;
      background-color: #fffefe;
      box-sizing: border-box;
      overflow: hidden;
      border: solid 1px #eee;
      margin-top: 30px;
    }
    .theneBtn {
      background-color: $theme !important;
      border-color: $theme !important;
    }
  }

  .foot {
    margin-bottom: 40px;
  }
}
</style>
